import { createContext } from "react";

const userContext = createContext({ name: "shubham" });

export default userContext;
